export default "__VITE_ASSET__BspBk6$6__"